import React, { useEffect, useRef } from 'react';
import "../../styles.css"
export default function SelectTemplateCard({
  urlToCreateTemplate,
  setTemplateOnTheURL,
  imgSource,
  title,
  description,
  isExclusive,
  type,
  template_id,
  template_type,
  htmlData
}) {
  const iFrameRef = useRef(null);

  const htmlInIframe = (htmlData) => {
    if (!iFrameRef.current)
      return
      try{
        var doc = iFrameRef.current.contentWindow.document;
      doc.open();
     doc.write(htmlData);
      doc.close();
      }catch(e){console.log(e)}
  }

  useEffect(() => {
    if (htmlData) {
      htmlInIframe(htmlData)
    }
  }, [template_id,htmlData])
  return (
    <div style={{ width: 350, height: 330 }} className="eqrwrew m-2 p-2">
      <a
        className='template-card'
        onClick={() =>
          type == 'edit' ? urlToCreateTemplate() : setTemplateOnTheURL({ template_id, template_type })
        }
      >
        {
          imgSource ? <figure className='template-img' style={{ paddingLeft: '20px', paddingRight: '20px' }} ><img src={imgSource} /></figure> : <div className='iframePreview' style={{ height: "220px", overflow: "hidden" }} >
            <div className='iframeOverlay' style={{ width: "280px", height: "220px", zIndex: 10000, position: "absolute", backgroundColor: "gray", opacity: 0, transition: "opacity .2s ease-out 0s", borderRadius: "1.5em" }}>
              {/* <div className='templatePreview'>
                <i class="fas fa-eye" ></i>
                <p>Preview</p>
              </div> */}
            </div>
            <iframe className='ml-5' ref={iFrameRef} scrolling="no" style={{ width: "600px", height: "1200px", transform: "scaleX(0.3) scaleY(0.22)", transformOrigin: "0 0", border: "none" }} sandbox="allow-same-origin"></iframe>
          </div>
        }

        <figcaption className='template_info text-center'>
          <h3>{title}</h3>
          <p>{description}</p>
        </figcaption>
      </a>
    </div>
  );
}
